import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      color: theme.value.typography.color,
      fontFamily: theme.value.typography.fontFamily,
    },
    '&__container': {
      gap: theme.value.spacing,
      display: 'flex',
      flexDirection: 'column',
      width: '358px',
    },
    '&__label': {
      display: 'block',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '20px',
    },
    '&__textarea-wrapper': {
      position: 'relative',
    },
    '&__textarea': {
      display: 'flex',
      width: '100%',
      height: '80px',
      overflow: 'auto',
      resize: 'none',
      background: '#FFF',
      border: `1px solid ${theme.value.colors.gray.light2}`,
      borderRadius: theme.value.input.borderRadius,
      padding: '6px 8px',
      gap: '8px',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '22px',
      '&::placeholder': {
        color: theme.value.colors.gray.medium2,
      },
      '&:hover': {
        borderColor: theme.value.colors.gray.medium2,
      },
      '&:focus': {
        borderColor: theme.value.colors.primary.light1,
      },
      '&:focus-visible': {
        outline: 'none',
      },
      '&:disabled': {
        background: theme.value.colors.gray.light3,
        borderColor: theme.value.colors.gray.light3,
      },
    },
    '&__textarea--auto-resize': {
      overflowY: 'auto',
    },
    '&__helper-text': {
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '18px',
      color: theme.value.colors.gray.medium1,
    },
    '&--error &__textarea, &error &__textarea:focus': {
      borderColor: theme.value.colors.error,
    },
    '&--error &__helper-text': {
      color: theme.value.colors.error,
    },
    '&--full-width': {
      width: '100%',
    },
  }));

  return baseClass;
};
